{
  "headings": {
    "start": "Starten",
    "end": "Ende",
    "duration": "Durst.",
    "zero": "Null +/-",
    "activity": "Aktivität",
    "location_space": "Ort/Raum"
  },
  "actions": {
    "insert_row_below": "Zeile darunter einfügen",
    "insert_row_below_alt": "Ein Symbol, das „Zeile darunter einfügen“ anzeigt",
    "insert_row_above": "Zeile darüber einfügen",
    "insert_row_above_alt": "Ein Symbol, auf dem „Zeile oben einfügen“ angezeigt wird",
    "export_as_excel": "Als Excel exportieren"
  },
  "activity": {
    "start": "beginnt",
    "zero": "NULL ZEIT"
  },
  "deleting": {
    "deleting_affects_all_instances": "Das Löschen wirkt sich auf alle Instanzen aus",
    "delete_activity_description_1": "Durch das Löschen dieser Aktivität werden auch alle Instanzen gelöscht, bei denen sie an anderen Tagen wiederholt werden soll",
    "delete_activity_description_2": "Wenn du die Wiederholungseinstellungen lieber nur bearbeiten möchtest, anstatt sie zu löschen, klicke auf die Startspalte"
  },
  "add": {
    "Event unit": "Geplanten Artikel hinzufügen",
    "Activity": "Aktivität hinzufügen"
  },
  "done": "Erledigt",
  "export_form": {
    "title": "DCAS exportieren",
    "days_to_export": "Tage zum Exportieren",
    "all_days": "Alle Tage",
    "all_days_desc": "Exportieren Sie alle DCAS-Tabellen für diesen Veranstaltungsort in eine einzige Excel-Datei",
    "selected_day": "Ausgewählter Tag",
    "selected_day_desc": "Exportiert das ausgewählte DCAS in eine Excel-Datei"
  }
}